import { Avatar, Typography } from "@mui/material";

interface IProfileAvatarProps {
  image?: string;
  textToShow: string;
  styles?: any;
}

export const ProfileAvatar = (props: IProfileAvatarProps) => {
  const { image, textToShow, styles } = props;

  const IMAGE_SERVER = process.env.REACT_APP_IMAGES_ENDPOINT;

  return (
    <Avatar
      src={image ? `${IMAGE_SERVER}/${image}` : ""}
      sx={{
        backgroundColor: "#F4E5ED",
        width: "41px",
        height: "41px",
        borderRadius: "50%",
        ...styles,
      }}
    >
      <Typography
        color="#8d004c"
        fontWeight={500}
        fontSize={"16px"}
        lineHeight={"20.8px"}
      >
        {textToShow}
      </Typography>
    </Avatar>
  );
};
